import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-37712a58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]



import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "SocialMediaButton",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    color: {},
    icon: {},
    link: {},
    textColor: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _directive_motion_slide_visible_once_left = _resolveDirective("motion-slide-visible-once-left")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "a",
      href: props.link,
      style: _normalizeStyle({ backgroundColor: props.color })
    }, [
      _createElementVNode("img", {
        class: "logo",
        src: props.icon
      }, null, 8, _hoisted_3),
      _createElementVNode("h2", {
        style: _normalizeStyle({ color: props.textColor })
      }, _toDisplayString(props.title), 5)
    ], 12, _hoisted_2)
  ])), [
    [_directive_motion_slide_visible_once_left]
  ])
}
}

})